import { useFeature } from "@/lib/features";
import { usePermission } from "@/lib/permissions";

/**
 * Whether the caller can reach Maxwell at all — the tenant holds the
 * `maxwell` feature AND the caller's permission set grants `maxwell.use`.
 *
 * Both halves are required, and every Maxwell entry point must read this one
 * hook rather than re-deriving the pair. The server already enforces both on
 * every `/api/maxwell/*` handler, so a surface that checks only the feature
 * advertises a workspace the caller gets a 403 from (AB#8477): revoking
 * "Use Maxwell" in a permission set left the sidebar entry, the rail, the
 * floating button and the user-menu toggle all still rendering.
 */
export function useMaxwellAccess(): boolean {
  const feature = useFeature("maxwell");
  const permitted = usePermission("maxwell.use");
  return feature && permitted;
}
